import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import Question from "../../../Question";
import Tooltip from "./Tooltip";
import LearnMore from "../../../LearnMore";
import "./index.scss";

const SimpleTitle = (props) => {
  const { optionName, tooltip, boldText, text, learnMorePath } = props;
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <div className="GP-C-O-O-ST">
      <b>{t(boldText)}</b>
      {t(text)}
      <Question
        tooltip={<Tooltip tooltip={tooltip} optionName={optionName} />}
        isComplexContent
      />
      {learnMorePath && <LearnMore path={learnMorePath} />}
    </div>
  );
};

SimpleTitle.propTypes = {
  optionName: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  boldText: PropTypes.string,
  text: PropTypes.string,
  learnMorePath: PropTypes.string,
};

export default SimpleTitle;
